var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Toast } from "@/composables/toast";
export function browserSupportsPushNotifications() {
    return "Notification" in window;
}
export function handlePermission(permission) {
    if (permission === "granted") {
        new Notification("Notifications enabled", {
            icon: "static/favicon.ico",
        });
        return true;
    }
    else {
        Toast.info("Push notifications disabled, please re-enable through browser settings.");
        return false;
    }
}
export function togglePushNotifications() {
    return __awaiter(this, void 0, void 0, function* () {
        if (browserSupportsPushNotifications()) {
            const permission = yield Notification.requestPermission();
            return handlePermission(permission);
        }
        return false;
    });
}
export function pushNotificationsEnabled() {
    if (browserSupportsPushNotifications()) {
        return Notification.permission === "granted";
    }
    return false;
}
